<template>
	<div class="socials">
		<a v-for="medium in socials" :key="medium.ID" :class="medium.platform" :href="medium.url" target="_blank">
			<font-awesome-icon v-if="medium.platform == 'twitter'" icon="fa-brands fa-x-twitter" size="1x" />
			<font-awesome-icon v-else :icon="`fa-brands fa-${medium.platform}`" size="1x" />
		</a>
	</div>
</template>

<script setup>
defineProps({
	socials: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.socials .tripadvisor {
	background: url('~/assets/images/tripadvisor-white.svg') no-repeat center center;
	background-size: 22px;
	width: 40px;
	height: 40px;
	line-height: 40px;
}

.socials .tripadvisor:hover {
	background: url('~/assets/images/tripadvisor-hover.svg') no-repeat center center;
	background-size: 22px;
}

.socials {
	display: flex;
	align-items: center;
	place-content: center flex-start;

	a {
		color: var(--light-background-color);
		display: flex;
		align-items: center;
		place-content: center center;
		line-height: 40px;
		text-align: center;
		font-size: 22px;
		margin: 8px 16px 8px 0;
		text-decoration: none;

		&:hover {
			color: #fff;
		}
	}
}

@media (max-width: 680px) {
	footer .socials {
		justify-content: center;
	}
}
</style>
